document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-menu-panel]');
  const search = document.querySelector('[data-search-panel]');
  const overlay = document.querySelector('[data-overlay]');

  const syncOverlay = () => {
    const open = menu?.classList.contains('is-open') || search?.classList.contains('is-open');
    overlay?.classList.toggle('is-open', Boolean(open));
    document.body.classList.toggle('panel-open', Boolean(open));
  };

  const setPanel = (panel, open) => {
    panel?.classList.toggle('is-open', open);
    panel?.setAttribute('aria-hidden', String(!open));
    syncOverlay();
  };

  document.querySelectorAll('[data-open-menu]').forEach((button) => {
    button.addEventListener('click', () => setPanel(menu, true));
  });
  document.querySelectorAll('[data-close-menu]').forEach((button) => {
    button.addEventListener('click', () => setPanel(menu, false));
  });
  document.querySelectorAll('[data-open-search]').forEach((button) => {
    button.addEventListener('click', () => {
      setPanel(search, true);
      window.setTimeout(() => search?.querySelector('input')?.focus(), 250);
    });
  });
  document.querySelectorAll('[data-close-search]').forEach((button) => {
    button.addEventListener('click', () => setPanel(search, false));
  });
  overlay?.addEventListener('click', () => {
    setPanel(menu, false);
    setPanel(search, false);
  });
  document.querySelectorAll('[data-panel-link]').forEach((link) => {
    link.addEventListener('click', () => {
      setPanel(menu, false);
      setPanel(search, false);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setPanel(menu, false);
      setPanel(search, false);
    }
  });

  const searchForm = document.querySelector('[data-market-search]');
  searchForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const query = searchForm.querySelector('input')?.value.trim().toLowerCase();
    const cards = [...document.querySelectorAll('[data-market-product]')];
    cards.forEach((card) => {
      const matches = !query || card.textContent.toLowerCase().includes(query);
      card.hidden = !matches;
    });
    setPanel(search, false);
    document.querySelector('#collection')?.scrollIntoView({ behavior: 'smooth' });
  });
});
